import { defineComponent as _defineComponent } from 'vue'
import { listItemProps } from './list';
import spaceFormat from '../../utils/spaceFormat';


export default /*#__PURE__*/_defineComponent({
  __name: 'listItem',
  props: listItemProps,
  setup(__props) {

const props = __props



return { __sfc: true,props, spaceFormat }
}

})